<template>
  <div>
    <div class="container container-title-cleed">
      <div v-if="selectedOption === '5'" class="sizeTitle">
        <Title :title="i18n['title']" :level="3" />
        <p v-if="selectBrand !== ''" style="display: block; margin: auto; width: max-content;">
          <b>{{ selectBrand.toUpperCase() }}</b>
        </p>
      </div>
      <div class="unit-buttons">
        <button v-for="unit in units" :key="unit" class="unit-button" :class="{ active: isSelected(unit) }"
                @click="selectUnit(unit)"
        >
          {{ unit }}
        </button>
      </div>
      <div v-if="!isSizeInput()">
        <select v-model="selectedSize" class="select-size">
          <option value="">
            {{ i18n['nullValue'] }}{{ selectedUnit }}
          </option>
          <option v-for="size in sizes[selectedUnit]" :key="size" :value="size">
            {{ size }} {{ selectedUnit }}
          </option>
        </select>
      </div>
      <div v-else>
        <input id="size-cm-inch" v-model="selectedSize" type="number" :placeholder="i18n['placeholder'] + selectedUnit" :min="sizesMinMax[selectedUnit][0]" :max="sizesMinMax[selectedUnit][1]" step="0.1" :class="[errors ? 'select-size error' : 'select-size']" />
      </div>
      <span class="error-message">{{ errors }}</span>
      <div v-if="mesure" class="measure-text" @click="updateSelectedOption('3')">
        <span class="measure-instruction">{{ i18n['footGuidelink'] }}</span>
      </div>
    </div>
    <div v-if="selectedOption === '5'"> 
      <ButtonSubmit :text="i18n['button']" @submitButton="updateSelectedOption('2')" />
    </div>
    <div v-if="selectedOption === '1'">
      <div v-if="selectedUnit === 'CM' || selectedUnit === 'INCH'">
        <ButtonSubmit :text="i18n['button']" @submitButton="updateSelectedOption('2'); $emit('manfield-get-brands');" />
      </div>
      <div v-else>
        <ButtonSubmit :text="i18n['button']" @submitButton="updateSelectedOption('5'); $emit('manfield-get-brands');" />
      </div>
    </div>
  </div>
</template>

<script>
// import Title from "@/components/modal/ui/Title";
import store from "@/store";
import ButtonSubmit from "@/components/modal/ui/ButtonSubmit.vue";
import { customLogger } from "@/utils";

export default {
  name: "Size",
  components: {
    // Title,
    ButtonSubmit,
  },
  props: {
    selectedOption: {
      type: String,
      default: '5', // Provide a default value if appropriate
    },
    mesure: {
      type: Boolean,
      default: false,
    },
    i18n: {
      type: Object,
      default: () => ({}),
    },
    unitList: {
      type: Array,
      default: () => ([]),
    },
    sizeList: {
      type: Object,
      default: () => ([]),
    },
    sizeMinMax: {
      type: Object,
      default: () => ([]),
    },
    selectBrand: {
      type: String,
      default: () => ([]),
    },
    modeSelect: {
      type: String,
      default: () => ([]),
    },
  },
  data() {
    return {
      // first unit is the default one
      // selectedUnit: localStorage.getItem("input_size_type") || UNITS[0],
      // selectedSize: localStorage.getItem("foot_size") || "",
      selectedUnit: this.unitList[0],
      selectedSize: "",
      units: this.unitList,
      sizes: this.sizeList,
      sizesMinMax: this.sizeMinMax,
      errors: "",
    };
  },
  watch: {
    // mettre à jour les données en props
    unitList: function (newVal) {
      this.units = newVal;
      this.selectedUnit = newVal[0];
      this.selectedSize = "";
    },
    sizeList: function (newVal) {
      this.sizes = newVal;
      this.selectedSize = "";
    },
  },
  mounted() {

    if (store.state.user.modal_reco_sizeContent) {
      if (this.modeSelect === "normal") {
        if (this.selectedSize == "" && store.state.user.modal_reco_sizeContent.foot_size != "" && store.state.user.modal_reco_sizeContent.input_size_type != "") {
          this.selectedSize = store.state.user.modal_reco_sizeContent.foot_size;
          this.selectedUnit = store.state.user.modal_reco_sizeContent.input_size_type;
        }
      } else {
        if (store.state.user.modal_reco_sizeContent.shoes_brand_select != "" && store.state.user.modal_reco_sizeContent.input_size_type === this.unitList[0]) {
          this.selectedSize = store.state.user.modal_reco_sizeContent.foot_size;
          this.selectedUnit = store.state.user.modal_reco_sizeContent.input_size_type;
        }
      }
    }
  },
  methods: {
    selectUnit(unit) {
      this.selectedUnit = unit;
      this.selectedSize = "";
      this.errors = "";
    },
    //setDataInCookies() {
    //  localStorage.setItem("foot_size", this.selectedSize);
    //  localStorage.setItem("input_size_type", this.selectedUnit);
    //},
    isSelected(unit) {
      return this.selectedUnit === unit;
    },
    isSizeInput() {
      return this.selectedUnit === "CM" || this.selectedUnit === "INCH";
    },
    updateSelectedOption(value) {
    // customLogger("updateSelectedOption", value);
    // If the value is '2' or '5' and the selected size is empty, set an error message.
    if ((value === "2" || value === "5") && this.selectedSize === "") {
      this.errors = this.i18n['error'];
    } else if ((value === "2" || value === "5") && this.selectedSize !== "") {
      // Perform validation checks for the size
      if (this.selectedUnit === "CM" || this.selectedUnit === "INCH") {
        let min = this.sizesMinMax[this.selectedUnit][0];
        let max = this.sizesMinMax[this.selectedUnit][1];
        if (parseFloat(this.selectedSize) < min || parseFloat(this.selectedSize) > max) {
          this.errors = this.i18n['error'];
          return;
        }
      } else {
        if (this.unitList.indexOf(this.selectedUnit) === -1 || this.sizeList[this.selectedUnit].indexOf(parseFloat(this.selectedSize)) === -1) {
          this.errors = this.i18n['error'];
          return;
        }
      }
      // If the validation passes, update the Vuex state with the selected size and unit.
      store.state.user.modal_reco_sizeContent.foot_size = parseFloat(this.selectedSize);
      store.state.user.modal_reco_sizeContent.input_size_type = this.selectedUnit;
      
      // customLogger("store.state.user.modal_reco_size", store.state.user.modal_reco_sizeContent);
      
      // Emit an event to the parent component with the selected size and unit when the selected option is '2' or '5'.
      this.$emit('update-selected-option', value, this.selectedSize, this.selectedUnit);
    } else {
      // For other cases (such as initial selection or an invalid selection), just emit the value without size and unit.
      this.$emit('update-selected-option', value);
    }
  },
  },
};
</script>

<style scoped>
.container-title-cleed {
  width: 100% !important;
  display: flex !important;
  justify-content: center !important;
  flex-direction: column !important;
  background-color: #F0F0F0;
  margin-top: 20px;
}

.unit-buttons {
  display: flex !important;
  justify-content: space-around !important;
  margin :30px 38px !important;
}

.unit-button {
  font-size: 17px !important;
  padding: 7px 8px !important;
  cursor: pointer !important;
  margin: 0 2px !important;
  color: #A4A4A4 !important;
  border: 1px solid #000;
  border-radius: 5px;
}

.unit-button.active {
  color: #FFF !important;
  background-color: #000;
  border: 1px solid #000;
  border-radius: 4px;
}


.sizeTitle {
  margin-top: 21px !important; 
  margin-bottom: 0px !important;
}

.measure-text {
  font-size: 14px !important;
  color: #000 !important;
  margin-top: 30px !important;
  margin-bottom: 50px !important;
  

  text-align: center !important;
  font-style: italic !important;
  cursor: pointer !important;
}

.select-size {
  font-size: 18px !important;
  text-align: center !important;;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  box-sizing: border-box !important;
  padding: 15px 10px !important;
  margin-top: 10px !important;
  cursor: pointer !important;
  width: 80% !important;
  margin-left: auto !important;
  margin-right: auto !important;
  border: 1px solid black;
}

.select-size.error {
  border: 1px solid red;
}

.sizeTitle[level="3"], .sizeTitle[level="4"] {
  font-style: italic !important;
}

.error-message {
  color: red !important;
  font-size: 12px !important;
  margin-top: 5px !important;
  display: block;
  text-align: center;
  min-height: 16px;
}

select {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e") !important;
  background-position: right 0.5rem center !important;
  background-repeat: no-repeat !important;
  background-size: 1.5em 1.5em !important;
  padding-right: 2.5rem !important;
  -webkit-print-color-adjust: exact !important;
  color-adjust: exact !important;
  appearance: none !important;
}

</style>
